import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Platform } from '@app/classes';
import { AnalyticEvents } from '@app/enums';
import { ApplicantIndividualMessage } from '@app/models/recruiting/applicant-individual-message.model';
import { Applicant } from '@app/models/recruiting/applicant.model';
import { AnalyticService, AuthService, NotifyService } from '@app/services';
import { TranslatableKey } from '@app/types/translatable.type';
import { EmailHistoryIndexTable } from '../../services';

@Component({
    templateUrl: './emails.template.html',
    styleUrls: ['./emails.style.scss'],
})
export class EmailsComponent implements OnInit {
    hasRecruiterAccess = false;
    canShowApplicantIndividualMessages = false;
    isToggleEmailHistoryDialogOpen = false;
    emailHistoryTable: EmailHistoryIndexTable;
    isLoading = false;
    visibleToRecruitersAndHiringTeam = false;
    applicant: Applicant;

    private _checkboxRef?: HTMLInputElement;

    constructor(
        private auth: AuthService,
        private route: ActivatedRoute,
        private notify: NotifyService,
        private analyticService: AnalyticService
    ) {}

    async ngOnInit(): Promise<void> {
        this.applicant = this.route.parent.snapshot.data.models.get('applicant');
        this.hasRecruiterAccess = this.auth.can(Platform.recruiting.permission.recruiter);
        this.canShowApplicantIndividualMessages = this.applicant.showMessages;
        this.emailHistoryTable = new EmailHistoryIndexTable(this.applicant);
    }

    showEmailHistoryDialog(event?: Event): void {
        this.isToggleEmailHistoryDialogOpen = true;

        if (event?.target) {
            this._checkboxRef = event?.target as HTMLInputElement;
            this._checkboxRef.checked = this.applicant.showMessages;
        }
    }

    closeEmailHistoryDialog(): void {
        this.isToggleEmailHistoryDialogOpen = false;
    }

    onApplicantIndividualMessageClicked(_: ApplicantIndividualMessage): void {
        this.analyticService.trackEvent(AnalyticEvents.RecruitingApplicantProfileClickEmailHistory);
    }

    toggleEmailHistoryViewText(): TranslatableKey {
        return this.canShowApplicantIndividualMessages
            ? 'applicant-tracker.areYouSureYouWantToHideEmailHistory'
            : 'applicant-tracker.areYouSureYouWantToShowEmailHistory';
    }

    async toggleEmailHistory(): Promise<void> {
        this.isLoading = true;
        this.closeEmailHistoryDialog();

        this.applicant.showMessages = !this.applicant.showMessages;
        if (this._checkboxRef) {
            this._checkboxRef.checked = this.applicant.showMessages;
        }

        try {
            await this.applicant.param('company', this.auth.company.id).save();
            this.notify.success(
                this.canShowApplicantIndividualMessages
                    ? 'applicant-tracker.emailHiddenFromHiringTeam'
                    : 'applicant-tracker.emailVisibleToHiringTeam'
            );
            this.canShowApplicantIndividualMessages = this.applicant.showMessages;
            this.isLoading = false;
        } catch (err) {
            this.notify.error(err.message || 'applicant-tracker.couldNotToggleEmailVisibility');
            this.isLoading = false;
        }
    }
}
